import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import { Switch } from '@/global/components/Switch'
import ContentGuide from '@/global/guides/ContentGuide'
import Dialog from '@/global/guides/Dialog'
import { usePermissoesOutletContext } from '@/pages/Permissoes.context'
import { supervisor } from '@/service/api'
import { hasPermission } from 'hooks/useBackendMenu'
import { useParams } from 'react-router-dom'
import { toast } from 'sonner'

export default function AssociarPerfilPermissao() {
    const { data: permissoes } = usePermissoesOutletContext()
    const { id } = useParams()
    const { data = [], isLoading } = supervisor.useFetch({
        refetchOnWindowFocus: false,
    })
    const { mutateAsync } = supervisor.mutations.useUpdate({
        onSuccess: () => {
            toast.success('As alterações foram salvas!')
        },
        onError: e => {
            toast.error(e.message)
        },
        invalidateQuery: true,
    })

    if (!id) return null

    return (
        <Dialog.Root open={hasPermission(['update', 'Supervisores'])}>
            <Dialog.Title>Associar perfil de permissões</Dialog.Title>
            <Dialog.Content>
                <ContentGuide.DataGrid
                    loading={isLoading}
                    columns={[
                        {
                            headerName: 'Nome',
                            field: 'nome',
                            valueGetter: ({ value, row: { email, cpf } }) =>
                                value || cpf || email,
                            maxWidth: 200,
                        },
                        {
                            headerName: 'Perfil atual',
                            field: 'perfil',
                            valueGetter: ({
                                row: {
                                    Usuario: { perfilPermissaoId },
                                },
                            }) =>
                                permissoes.find(
                                    it => it.id == perfilPermissaoId,
                                )?.nome || 'nenhum',
                            maxWidth: 200,
                        },
                        {
                            ...optionsColumn,
                            headerName: 'Associar',
                            field: 'associado',
                            valueGetter: ({
                                row: {
                                    Usuario: { perfilPermissaoId },
                                },
                            }) => perfilPermissaoId == id,
                            renderCell: ({ value, row }) => {
                                return (
                                    <Switch
                                        checked={value}
                                        onChange={e =>
                                            mutateAsync({
                                                id: row.id,
                                                Usuario: {
                                                    perfilPermissaoId: !e.target
                                                        .checked
                                                        ? null
                                                        : Number(id),
                                                },
                                            })
                                        }
                                    />
                                )
                            },
                        },
                    ]}
                    rows={data}
                    ToolbarProps={{
                        hideFilterButton: true,
                        showQuickFilter: true,
                    }}
                    hideFooter
                />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
